import { atom } from "recoil";

/**
 * Atomes Recoil du Data Assistant.
 *
 * Extraits de useDataAssistant.ts : ce module importe ./api,
 * ./api/eventProcessor et ./types. Tout fichier qui importait un atom depuis
 * le hook (App.tsx, Navigation, sidebar…) tirait donc l'ensemble de ce graphe
 * dans main.js, malgré le lazy sur la route /data-assistant/.
 *
 * Ce fichier ne dépend que de recoil : il peut être importé de n'importe où
 * sans coût pour le bundle.
 */

// Incrémenté pour forcer le remontage de <DataAssistant /> (prop `key` posée
// dans App.tsx).
export const conversationResetAtom = atom<number>({
  key: "conversationResetAtom",
  default: 0,
});

// Discussion to load on the next mount of <DataAssistant />. null = a brand-new
// conversation. Set it before bumping conversationResetAtom (which remounts the
// page), so the freshly-mounted hook reads the right target.
export const selectedDiscussionIdAtom = atom<number | null>({
  key: "selectedDiscussionIdAtom",
  default: null,
});

// Bumped after each completed turn so the history lists (sidebar / search page)
// refetch and pick up a freshly created conversation or an (re)generated title
// without waiting for a full reset.
export const conversationsRefreshAtom = atom<number>({
  key: "conversationsRefreshAtom",
  default: 0,
});

// Session-scoped "don't ask again" for delete confirmation. Deliberately not
// persisted: it resets on reload so a confirmation reappears each session,
// refreshing the user's intent rather than silently deleting forever after one
// checkbox click.
export const skipDeleteConfirmAtom = atom<boolean>({
  key: "nancieSkipDeleteConfirmAtom",
  default: false,
});

// Live id of the conversation currently shown by <DataAssistant /> (null when
// it's a brand-new, not-yet-persisted one). Mirrors the hook's local
// discussionId so the delete flow (run from the sidebar/search) can tell when
// the user just deleted the conversation they are actively viewing.
export const activeDiscussionIdAtom = atom<number | null>({
  key: "nancieActiveDiscussionIdAtom",
  default: null,
});

// Open state of the Nancie sidebar when it is rendered as a temporary overlay
// drawer (mobile). The toggle lives in the global <Navigation />, while the
// drawer itself lives in <NancieSidebar />, so the state is shared here.
// Ignored on desktop, where the sidebar is permanently inline.
export const nancieSidebarOpenAtom = atom<boolean>({
  key: "nancieSidebarOpenAtom",
  default: false,
});
